import { CURRENCIES, NO_CURRENCY, curLabel, money } from "@/lib/finance";

export const CurrencyTotals = ({ totals, rows }) => {
  const present = [...CURRENCIES, NO_CURRENCY].filter((k) => totals[k]);
  const keys = present.length ? present : ["MXN"];
  return (
    <div data-testid="currency-totals" className="-mx-4 px-4 flex gap-3 overflow-x-auto no-scrollbar snap-x snap-mandatory pb-1">
      {keys.map((k) => {
        const t = totals[k];
        return (
          <div key={k} data-testid={`currency-total-${k.toLowerCase().replace("_", "-")}`}
            className={`snap-start shrink-0 w-[84%] rounded-2xl p-4 ${k === "MXN" ? "bg-[#0b2a47] text-white" : "c-card"}`}>
            <div className="flex items-center justify-between">
              <span className={`font-mono text-xs tracking-widest ${k === "MXN" ? "text-[#d4ac4e]" : "c-accent"}`}>{curLabel(k)}</span>
              <span className="text-[11px] opacity-60">{t ? `${t.count} registro(s)` : "Sin registros"}</span>
            </div>
            <div className="mt-3 space-y-1.5">
              {rows.map(({ key, label, strong }) => (
                <div key={key} className="flex items-baseline justify-between gap-2">
                  <span className="text-xs opacity-70">{label}</span>
                  <span data-testid={`total-${k.toLowerCase()}-${key}`} className={`font-mono tabular-nums whitespace-nowrap ${strong ? "text-base font-bold" : "text-sm"}`}>
                    {money(t ? t[key] : 0)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
